import { render, staticRenderFns } from "./Discount.vue?vue&type=template&id=7aec6a4c&"
import script from "./Discount.vue?vue&type=script&setup=true&lang=js&"
export * from "./Discount.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Discount.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports